import Blogs from "../Components/Blogs"


function Index() {
  return (
    <Blogs />
  )
}

export default Index